import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogRef } from '@tylertech/forge-angular';
import { environment } from 'src/environments/environment';

/**
 * Hosts the Cloudflare Turnstile widget inside a Forge dialog. The SDK script is
 * expected to already be loaded (CaptchaService handles that). On a successful
 * solve the dialog closes and returns the Turnstile token; on cancel it returns
 * null.
 */
@Component({
  selector: 'app-captcha-dialog',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './captcha-dialog.component.html',
  styleUrls: ['./captcha-dialog.component.scss']
})
export class CaptchaDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('captchaContainer', { static: true }) captchaContainer!: ElementRef<HTMLElement>;

  private _widgetId?: string;

  constructor(private readonly _dialogRef: DialogRef<string | null>) {}

  ngAfterViewInit(): void {
    const sdk = window.turnstile;
    if (!sdk) {
      // SDK failed to load; close without a token so the caller can fall back.
      this._dialogRef.close(null);
      return;
    }

    this._widgetId = sdk.render(this.captchaContainer.nativeElement, {
      sitekey: environment.turnstile.siteKey,
      theme: 'auto',
      callback: (token: string) => this._dialogRef.close(token),
      'error-callback': () => this._dialogRef.close(null),
      // A token that expires before the user finishes is unusable; reset so a
      // fresh challenge can be attempted.
      'expired-callback': () => this._widgetId && sdk.reset(this._widgetId)
    });
  }

  ngOnDestroy(): void {
    if (this._widgetId && window.turnstile) {
      window.turnstile.remove(this._widgetId);
    }
  }

  cancel(): void {
    this._dialogRef.close(null);
  }
}